<template>
  <header class="content-title">
    <div class="title-left">
      <slot name="header"></slot>
      <p>
        {{ title }}
        <span v-if="remark">-{{ remark }}</span>
      </p>

      <search v-if="searchPages.indexOf($route.name) > -1" :handle-search="handleSearch"></search>
      <!-- 搜索栏右侧的扩展区域，例如数据管理的展开/折叠链接 -->
      <slot name="search-right"></slot>
    </div>
    <div class="title-right">
      <slot name="right"></slot>
      <grid-toggle v-if="reportTypePages.indexOf($route.name) > -1 && $store.state.systemType !== 'JD'" />
      <div class="button-wrapper">
        <el-button size="mini" class="btn-info-cus" type="info" plain v-if="$route.name == 'mineCollect' && !isCollect"
          icon="el-icon-edit-outline" @click="collectClick">
          {{ $translate('management') }}
        </el-button>
        <el-button size="mini" class="btn-info-cus" type="info" plain v-if="$route.name == 'mineCollect' && isCollect"
          icon="el-icon-check" @click="collectClick">
          {{ $translate('Completed') }}
        </el-button>
        <!-- TODO: 暂时隐藏-->
        <!-- <el-button size="mini" v-if="hotPages.indexOf($route.name) > -1" :icon="hotSortAsc?'icon-sort-up':'icon-sort-down'" v-preventReClick="1000" @click="hotSort($event)">热门</el-button> -->
        <el-button size="mini" class="btn-info-cus" type="info" plain v-if="fullPages.indexOf($route.name) > -1"
          icon="icon-full-screen" v-preventReClick="1000" @click="fullScreen($event)">
          {{ $translate('packup') }}
        </el-button>
        <el-button size="mini" class="btn-info-cus" type="info" plain
          v-if="sharePage.indexOf($route.name) > -1 && $store.state.uiConfig.reportSharing != 'off'" icon="icon-share"
          @click="sharing">
          {{ $translate('share') }}
        </el-button>
        <slot name="button"></slot>
      </div>
    </div>
  </header>
</template>
<script>
import GridToggle from "./gridToggle.vue";
import search from "./search";
export default {
  components: { search, GridToggle },
  props: {
    hotSortAsc: {
      type: Boolean,
    },
    hotSort: {
      type: Function,
    },
    fullScreen: {
      type: Function,
    },
  },
  data() {
    return {
      href: "",
      dialogVisible: false,
      // KPIPush
      searchPages: [
        "mineView",
        "mineCollect",
        "design",
        "tasktodo",
        "taskdone",
        "initprocess",
        "myfile",
        "datamanagement",
      ],
      reportTypePages: ["mineView", "reportList"],
      fullPages: ["reportView"],
      hotPages: ["mineView"],
      sharePage: ["reportView"], //'mineView', 'mineCollect', "reportList",
      searchInfo: "",
      isCollect: false,
    };
  },
  computed: {
    title() {
      let str = this.$route.meta.title;
      if (str && str.indexOf("$t-") > -1) {
        let strArr = str.split("-");
        if (strArr[strArr.length - 1] === "mine") {
          str = "@" + this.$translate(strArr[strArr.length - 1]);
        } else {
          str = this.$translate(strArr[strArr.length - 1]);
        }
      }
      return str || "";
    },
    remark() {
      return this.$route.meta.remark || "";
    },
  },
  mounted() {
    if (sessionStorage.getItem("reportStyleType")) {
      this.$store.commit(
        "setReportStyleType",
        sessionStorage.getItem("reportStyleType")
      );
    }
  },
  methods: {
    sharing() {
      this.$refs.sharePages.dialogVisible =
        !this.$refs.sharePages.dialogVisible;
    },
    handleSearch(val) {
      this.searchInfo = val;
      this.$emit("search");
    },
    collectClick() {
      this.isCollect = !this.isCollect;
      this.$emit("handleCollectClick", this.isCollect);
    },
  },
};
</script>
<style lang="scss" scoped>
.content-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 0.5rem;
  /* padding: 10px 15px; */
  min-width: 680px;
  p {
    font-size: 1.3em;
    color: $level1-text-color;
    padding-right: 0;
  }
  .title-left {
    display: flex;
    align-items: center;
    height: 100%;
    /* padding-left: 15px; */
    padding-top: 10px;
    color: $level1-text-color;
    font-weight: bold;
    color: #041e42 !important;
    .earth_search {
      width: 2.6rem;
    }
  }
  .title-right {
    display: flex;
    height: 0.3rem;
    .button-wrapper {
      button + button {
        margin-left: 6px;
        padding-left: 10px !important;
        padding-right: 10px !important;
      }
    }
  }
}
</style>
